import React, { useState, useEffect } from 'react'
import { Columns, Header } from '../../../../components/elements'
import moment from 'moment'
import './bikeModelDescription.css'

const BikeModelDescription = (props) => {
  const [truncated, setTruncated] = useState(false)
  const [helmets, setHelmets] = useState(props.bikeData?.gear?.helmets || [])
  const modelDescription = {
    ...(props.bikeData?.engine_type
      ? { Engine: props.bikeData?.engine_type }
      : null),
    ...(props.bikeData?.bike_engine
      ? { Displacement: props.bikeData?.bike_engine + ' cc' }
      : null),

    ...(props.bikeData?.power ? { 'Power (HP)': props.bikeData?.power } : null),
    ...(props.bikeData?.torque ? { Torque: props.bikeData?.torque } : null),
    ...(props.bikeData?.fuel_system
      ? { 'Fuel System': props.bikeData?.fuel_system }
      : null),
    ...(props.bikeData?.transmission_type
      ? { 'Transmission Type': props.bikeData?.transmission_type }
      : null),
    ...(props.bikeData?.wet_weight_lbs
      ? { 'Wet Weight': props.bikeData?.wet_weight_lbs + ' lbs' }
      : null),
    ...(props.bikeData?.bike_seat_heigh
      ? { 'Seat Height': props.bikeData?.bike_seat_height + ' in' }
      : null),
  }

  const bikeConditionDetails = {
    ...(props.bikeData?.bike_odometer
      ? { Odometer: props.bikeData?.bike_odometer + ' miles' }
      : null),
    ...(props.bikeData?.last_serviced_date_formatted
      ? {
        Serviced: props.bikeData?.last_serviced_date_formatted,
      }
      : null),
    ...(props.bikeData?.tire_tread_formatted
      ? { 'Tire Condition': props.bikeData?.tire_tread_formatted }
      : null),
  }

  useEffect(() => {
    let textHeight = document.getElementById('bikemodel-table')
    if (textHeight?.offsetHeight > 150) {
      setTruncated(true)
    }
  }, [])

  const buildTableClassName = () => {
    if (truncated) {
      return 'bikemodel-table truncated'
    } else {
      return 'bikemodel-table'
    }
  }

  return (
    <Columns>
      <Columns.Column>
        <div className="things-to-know">
          <Header
            renderas="h2"
            size={5}
            className="has-text-weight-bold mb-4 ttk-header"
          >
            Things to Know
          </Header>
        </div>
        <div className="bike-condition-description">
          <p className="bike-condition-table">
            <div className='is-flex is-align-items-center'>
              <h3 className="condition-name">Condition (Reported by Host)</h3>
              <div className='is-flex is-align-items-center mb-2'>
                <img className='ml-2' src="/static/images/bikeProfileSectionImages/spanner.JPG" alt="spanner-image" style={{ width: 16, height: 16 }}/>
              </div>
            </div>
            <table>
              <tbody>
                {Object.keys(bikeConditionDetails).map((key, index) => (
                  <tr className="description-row" key={index}>
                    <td className="first-column">{key}</td>
                    <td className="second-column">
                      <p dangerouslySetInnerHTML={{ __html: bikeConditionDetails[key] }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </p>
        </div>
        <div className="bike-condition-description">
          <p className="bike-condition-table">
            {helmets.length > 0 && (
              <>
                <div className='is-flex is-align-items-center'>
                  <h3 className="condition-name">Helmets Available</h3>
                  <img className='mb-1 ml-2' src="/static/images/bikeProfileSectionImages/helmet.JPG" alt="helmet-image" style={{ width: 14, height: 14, opacity: 0.8 }}/>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className='pt-1 pb-1'>Size</th>
                      <th className='pt-1 pb-1'>Type</th>
                    </tr>
                    {helmets.map((item, index) => (
                      <tr className="description-row" key={item.size}>
                        <td className="first-column">{item.size}</td>
                        <td className="second-column">
                          <p dangerouslySetInnerHTML={{ __html: item.type }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </p>
        </div>
        {Object.keys(modelDescription)?.length > 0 && (
          <div className="bikemodel-description">
            <p id="bikemodel-table" className={buildTableClassName()}>
              <span className="bikemodel-name">
                About the {props.bikeData?.bike_year}{' '}
                {props.bikeData?.bike_make} {props.bikeData?.bike_model}
              </span>
              <img className='mb-1' src="/static/images/bikeProfileSectionImages/engine.JPG" alt="engine-image" style={{ marginLeft: '0.4rem', verticalAlign: 'middle', width: 18, height: 14 }}/>
              <table>
                <tbody>
                  {Object.keys(modelDescription).map((key, index) => (
                    <tr className="description-row" key={index}>
                      <td className="first-column">{key}</td>
                      <td className="second-column">
                        <p dangerouslySetInnerHTML={{ __html: modelDescription[key] }} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </p>
            {/* {this.state.truncated && (
              <div className="bikemodel-table-read-more">
                <a
                  style={{ textDecoration: 'none' }}
                  onClick={() => this.setState({ truncated: false })}
                >
                  See More &nbsp;
                </a>
                <i className="fas fa-caret-square-down"></i>
              </div>
            )} */}
          </div>
        )}
      </Columns.Column>
    </Columns>
  )
}

export default BikeModelDescription
